import React from "react";

export default function lock({ color = "#232832", ...restProps }) {
  return (
    <svg
      id="LockIcon"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27.8 38"
      width="27.8"
      height={38}
      {...restProps}
    >
      <path
        d="M119.8,100.8h-3v-3a9.3,9.3,0,1,0-18.5-1.9,6.1,6.1,0,0,0,0,1.9v3H95.2a1.6,1.6,0,0,0-1.6,1.6V124a1.7,1.7,0,0,0,1.6,1.5h24.6a1.7,1.7,0,0,0,1.6-1.5V102.4A1.6,1.6,0,0,0,119.8,100.8ZM109,116v3.3h-3V116a4.6,4.6,0,0,1,1.5-9,4.7,4.7,0,0,1,4.6,4.6A4.8,4.8,0,0,1,109,116Zm4.7-15.2H101.3v-3a6.2,6.2,0,1,1,12.4,0h0Z"
        transform="translate(-93.6 -87.5)"
        style={{ fill: color }}
      />
    </svg>
  );
}
